import { render, staticRenderFns } from "./LifeService.vue?vue&type=template&id=2862bd82&scoped=true&"
import script from "./LifeService.vue?vue&type=script&lang=js&"
export * from "./LifeService.vue?vue&type=script&lang=js&"
import style0 from "./LifeService.vue?vue&type=style&index=0&id=2862bd82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2862bd82",
  null
  
)

export default component.exports